"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
// @ts-ignore-next-line importsNotUsedAsValues
require("react");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const ActionBarItemListItem = (props) => {
    const { hasLink, icon, onClick, className, children } = props, remainingProps = tslib_1.__rest(props, ["hasLink", "icon", "onClick", "className", "children"]);
    const classes = (0, classnames_1.default)('ActionBarItemListItem', className);
    const iconClasses = (0, classnames_1.default)('ActionBarItemListItemIcon', 'rioglyph', icon);
    const btnClasses = (0, classnames_1.default)('ActionBarItemListItemButton');
    return ((0, jsx_runtime_1.jsxs)("li", Object.assign({}, remainingProps, { className: classes }, { children: [icon && (0, jsx_runtime_1.jsx)("span", { className: iconClasses }), hasLink && !onClick && (0, jsx_runtime_1.jsx)("span", { children: children }), onClick && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: btnClasses, onClick: onClick }, { children: children }))), !hasLink && !onClick && children] })));
};
ActionBarItemListItem.displayName = 'ActionBarItemListItem';
exports.default = ActionBarItemListItem;
